import {
  // CORE_CREATE_EVENT_REQUEST,
  // CORE_CREATE_EVENT_SUCCESS,

  CORE_LOAD_EVENTINFO_REQUEST,
  CORE_LOAD_EVENTINFO_SUCCESS,

  CORE_LOAD_EVENT_LOG_TITLE_REQUEST,
  CORE_LOAD_EVENT_LOG_TITLE_SUCCESS,

  // CORE_EDIT_EVENT_REQUEST,
  // CORE_EDIT_EVENT_SUCCESS,

  // CORE_DELETE_EVENT_REQUEST,
  // CORE_DELETE_EVENT_SUCCESS
} from '../../types'


const initialState = []
export default {
  events: (state = initialState, action) => {
    switch (action.type) {
      // case CORE_CREATE_EVENT_REQUEST:
      // case CORE_DELETE_EVENT_REQUEST:
      // case CORE_DELETE_EVENT_SUCCESS:
      //   return initialState
      // case CORE_CREATE_EVENT_SUCCESS:
      //   return action.payload
      case CORE_LOAD_EVENTINFO_REQUEST:
        return {}
      case CORE_LOAD_EVENTINFO_SUCCESS:
        if (action.payload[0]) {
          const payLoad = action.payload[0]
          return payLoad
        }
        else return {}
      // case CORE_EDIT_EVENT_REQUEST:
      //   return {}
      // case CORE_EDIT_EVENT_SUCCESS:
      //   return action.payload
      default:
        return state
    }
  },
  logTitle: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_EVENT_LOG_TITLE_REQUEST:
        return initialState
      case CORE_LOAD_EVENT_LOG_TITLE_SUCCESS:
        if (action.payload[0]) {
          const payLoad = action.payload[0]
          return payLoad
        }
        else return {}
      default:
        return state
    }

  }
}



// WEBPACK FOOTER //
// ./src/front/features/events/reducer.js